<template>
  <div v-if="currentUser">
    <component :is="homePage" :user="currentUser" />
  </div>
</template>

<script>
import ContractorHome from './features/ContractorHome.vue';
import TesEmployeeHome from './features/TesEmployeeHome.vue';
import ClientContactHome from './features/ClientContactHome.vue';
import SupplierContactHome from './features/SupplierContactHome.vue';
export default {
  name: 'Home',
  components: {
    ContractorHome,
    TesEmployeeHome,
    ClientContactHome,
    SupplierContactHome
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isContractor() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'Contractor')
      );
    },
    isTesEmployee() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'TES Employee')
      );
    },
    isClientContact() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'Client Contact')
      );
    },
    isSupplierContact() {
      return (
        this.currentUser &&
        this.currentUser.roles.map(r => r.role_name).some(role => role === 'Supplier Contact')
      );
    },
    homePage() {
      let page;
      if (this.isContractor) {
        page = 'ContractorHome';
      }
      if (this.isClientContact) {
        page = 'ClientContactHome';
      }
      if (this.isTesEmployee) {
        page = 'TesEmployeeHome';
      }
      if (this.isSupplierContact) {
        page = 'SupplierContactHome';
      }

      return page;
    }
  }
};
</script>

<style></style>
